<template lang="pug">
div
  v-row.pb-2.pb-md-0.mt-4(no-gutters)
    v-col(cols="12" md="8")
      v-tabs(v-model="tabs" color="basic700" :height="44" show-arrows active-class="font-semibold")
        v-tab.text-sm.font-medium.text-none All {{ totalCount ? `(${totalCount})` : '' }}
        v-tab.text-sm.font-medium.text-none Selected ({{ selectedCustomers ? selectedCustomers.length : '0' }})
    v-col(cols="12" md="4" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
  //- v-text-field.text-sm.round-xl.mt-4.search-field(v-model="searchText" placeholder="Search customer" outlined dense clearable height="48" hide-details="auto" @input="queryChanged")

  v-divider
  customer-filter-row.my-4(:filters.sync="filters" ref="filter")
  .data-table(style="min-height: 350px;")
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="customerList" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetchingCustomers || isFetching" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="selectCustomer")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-if="!tabs" v-model="checkAll" @change="onCheckedAll")
      template(#item.checked="{ item, headers, index }")
        yc-checkbox(v-model="item.checked" @change="onChecked(item)")
      template(#item.name="{ item, headers, index }")
        div.d-flex.my-3(style="max-width: 200px;")
          div(style="width: 30px;")
            v-responsive(:aspect-ratio="7/10" style="width: 30px;")
              v-card.fill-height(v-if="item.profile_image && item.profile_image.file" flat)
                v-img(:src="`https://img.yezza.io/50x50/${item.profile_image.path}`" height="100%" width="100%")
                  template(v-slot:placeholder)
                    v-row(class="fill-height ma-0" align="center" justify="center")
                      v-progress-circular(indeterminate color="grey")
              v-card.neutral300.fill-height(v-else flat)
                div.d-flex.align-center.justify-center.fill-height
                  v-icon(size="20") $yzi-user-03
          div.pl-2
            v-tooltip(top color="black" content-class="black tooltip-top-arrow")
              template(#activator="{ on, attrs }")
                div(v-bind="attrs" v-on="on" style="max-width: 145px;")
                  .text-sm.font-semibold.neutral700--text.cursor-help.truncate {{ item.name }}
              div(style="max-width: 600px;")
                .text-sm.font-semibold {{ item.name }}
                .text-xs(v-if="item.dob") {{ $options.filters.getAgeByYearMonthDay(item.dob) | displayAgeByYearMonthDay }} old
            div.d-flex.align-center
              y-chip.mr-2(v-if="item.urgent" label="Urgent" size="xs" color="red")
              .text-xs.neutral700--text.no-wrap(v-if="item.dob") {{ $options.filters.getAgeByYearMonthDay(item.dob) | displayAgeByYearMonthDay }} old
      

  div.d-flex.align-center(v-if="!tabs && totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomerFilterRow from '@/components/clinic/marketing/filters/CustomerFilterRow.vue'

export default {
  components: { CustomerFilterRow },
  props: {
    value: {
      required: true,
      type: Array,
      default: (() => [])
    },
    offer: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      showSearchField: false,
      isFetching: false,
      isFetchingCustomers: false,
      checkAll: false,
      tabs: 0,
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      searchText: null,
      customers: [],
      selectedCustomers: [],
      filters: [],
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    headers () {
      let headers = [
        { value: 'checked', text: '', sortable: false},
        { value: 'name', text: 'name', class: 'text-table-header'},
        { value: 'age', text: 'age', class: 'text-table-header'},
        { value: 'ic', text: 'id', class: 'text-table-header'},
        { value: 'segment', text: 'segment', class: 'text-table-header'},
      ]
      return headers
    },
    customerList () {
      if (this.tabs) {
        return this.selectedCustomers
      } else {
        return this.customers
      }
    },
    customersValue () {
      return this.selectedCustomers.map(m => m.id)
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.currentPage = 1
        this.fetchCustomers()
      }
    },
    customersValue (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.value.length && this.offer.id) {
        this.isFetching = true
        let params = {
          fields: 'customers',
          expand: 'customers'
        }
        this.$axios.get(`/marketing/${this.company.slug}/offers/${this.offer.id}`, { params })
          .then(resp => {
            this.selectedCustomers = resp.data.customers.map(m => { return { ...m, checked: true } })
            this.fetchCustomers()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isFetching = false
          })
      } else {
        this.fetchCustomers()
      }
    },
    fetchCustomers () {
      this.checkAll = false,
      this.isFetchingCustomers = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage
      }
      if (this.searchText) {
        params.search = this.searchText
      }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/marketing/${this.company.slug}/customers`, { params })
        .then(resp => {
          this.totalCount = resp.data.count
          let data = resp.data.results
          data.forEach(customer => {
            if (!customer.age && customer.dob) {
              customer.age = this.getAge(customer.dob)
            }
            customer.checked = false
            if (this.value.length) {
              if (this.value.includes(customer.id)) {
                customer.checked = true
                this.selectedCustomers[this.selectedCustomers.findIndex(f => f.id === customer.id)] = customer
              }
            }
          })
          this.customers = data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingCustomers = false
        })
    },
    pageChanged () {
      this.fetchCustomers()
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchCustomers()
    }, 750),
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    selectCustomer (item) {
      item.checked = !item.checked
      this.onChecked(item)
    },
    onChecked (item) {
      if (item.checked) {
        this.selectedCustomers.push(item)
      } else {
        this.checkAll = false
        this.selectedCustomers = this.selectedCustomers.filter(f => f.id !== item.id)
      }
    },
    onCheckedAll () {
      if (this.checkAll) {
        this.selectedCustomers = this.customers
        this.customers.map(m => m.checked = true)
      } else {
        this.selectedCustomers = []
        this.customers.map(m => m.checked = false)
      }
    },
    getAge(date) {
      var today = new Date();
      var birthDate = new Date(date);
      var age = today.getFullYear() - birthDate.getFullYear();
      var month = today.getMonth() - birthDate.getMonth();
      if (month < 0 ||(month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>